"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = requiresPermission;

var _react = _interopRequireWildcard(require("react")),
    _AuthorisationWrapper = require("../AuthorisationWrapper"),
    _hasPermission = _interopRequireDefault(require("./utils/hasPermission"));

function requiresPermission(_ref) {
  var ComponentToRender = _ref.ComponentToRender,
      requiredPermission = _ref.requiredPermission,
      Fallback = _ref.Fallback,
      isRoute = _ref.isRoute;
  return function (props) {
    return _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (_ref2) {
      var orgPermissions = _ref2.selectedOrganisation.permissions,
          resourcePermissions = props.permissions;
      return isRoute && (0, _hasPermission["default"])(requiredPermission, orgPermissions) || (0, _hasPermission["default"])(requiredPermission, resourcePermissions) ? _react["default"].createElement(ComponentToRender, props) : Fallback ? _react["default"].createElement(Fallback, props) : null;
    });
  };
}